import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UI_ROUTES } from 'src/app/app.contant';
import { IAPIResponse, IRoleResponse, RoleEnum } from 'src/app/modules/shared/models';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../../core/services/auth/auth.service';
import * as CryptoJS from 'crypto-js'; 
import { TabService } from 'src/app/modules/shared/services/tab.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public readonly ROUTES = UI_ROUTES;
  public userID : string = "";
  public GUID!:any;
  public templateDetails:any;

  public isManualLoginAllowed : boolean = false;
  constructor(
    private service: TabService,
    private authService: AuthService,
    private toastr : ToastrService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;
    const GUID = searchParams.get('GUID');
    this.isManualLoginAllowed = environment.manualLogin;
    if(this.isManualLoginAllowed) {
      if(this.userID){
        this.login();
      }
    } 
    
    if (GUID) {
      this.authService.getITracerAuthToken().subscribe((res: any) => {
        if(res.status == 200){ 
        this.authService.setIpepAccessToken(res.data.access_token);       
        this.authService.findUserDetails(GUID).subscribe((response: any) => {
          if (response.EmpDetails) {
            this.userID = response.EmpDetails[0].GID?response.EmpDetails[0].GID:"00"+response.EmpDetails[0].Vendor;
            const role = response.EmpDetails[0].GID?"SiemensUser":"Vendor";
            document.cookie = `UserRole = ${role}`;
            this.authService.deleteGuId(GUID,"Siemens").subscribe()
            this.login();
          }
        });
      }
      })   
    } else if(GUID == null){
      this.activatedRoute.queryParams.subscribe(params => {
        console.log(params);
        if (params['templateId'] || params['id']) {
          let templateId:any = params['templateId']?encodeURIComponent(params['templateId']):encodeURIComponent(params['id']);
          let access_token =params['access'];
          this.authService.setToken(access_token);
          this.authService.setUnregisteredVendorRole();

          if(params['templateId']){
            this.authService.checkTemplateId(templateId).subscribe((res:any)=>{
              if(res.status = 200){
                this.templateDetails = res.data;
                this.service.setData(this.templateDetails);
                this.router.navigate(['unregistered']);
              } 
            })
          } else{
            this.router.navigate([`unregitered-vendor-negotiation`],{
              queryParams:{id:templateId,supplierId:params['supplierId']}});
          }
        }
      })
    }
  }

  public login() : void {
    this.authService.fetchUserRoleByGID(this.userID).subscribe((res : any) => {
      const data = res.data;
      console.log("data",data);
      if(data?.length && data?.length > 1) {
        const roleSelection$ = this.authService.openLoginActionModal(data.map((x:any)=>x.role));
        roleSelection$.subscribe((role : RoleEnum) => {
          if(role) {
            const activeRole = data.find((x:any)=>x.role === role);
            this.authService.getToken(this.userID,activeRole.role).subscribe((response:any)=>{
              if(response.data?.access_token){
                this.authService.setToken(response.data?.access_token);
                activeRole && this.authService.updateStorageAndRedirect(activeRole,this.userID,response.data?.access_token);
              } else{
                this.toastr.error("Authendication Failed")
              }
            })
          }
        }); 
      } else {
        this.authService.getToken(this.userID,data[0].role).subscribe((response:any)=>{
          if(response.data?.access_token){
            this.authService.setToken(response.data?.access_token);
            data[0].role && this.authService.updateStorageAndRedirect(data[0],this.userID,response.data?.access_token);
            this.authService.refreshToken(response.data?.access_token)
          } else{
            this.toastr.error("Authendication Failed")
          }
        })
      }
    },
    (err) => {
      // this.toastr.error(err?.error?.message)
    });
  }

  public updateStorageAndRedirect(roleInfo : IRoleResponse) {
    roleInfo.gid = this.userID;
    console.log("roleInfo",roleInfo);
    
    this.authService.setUserRole(roleInfo.role as RoleEnum)
    this.authService.setUserDetails(roleInfo);
    this.authService.setUserId(this.userID);
    this.authService.routeRedirection(roleInfo.role);
    if(roleInfo.role == RoleEnum.BUYER || roleInfo.role == RoleEnum.SUPPLIER){
      // this.authService.checkPoApproverAcknowledgement().subscribe();
      this.authService.fetchPOHistory().subscribe();
    }
  }

}
